export const THEMES = {
  saffron: { main: "#C2410C", soft: "#FFF3E0", deep: "#7C2D12" },
  emerald: { main: "#047857", soft: "#ECFDF5", deep: "#064E3B" },
  maroon: { main: "#9F1239", soft: "#FFF1F2", deep: "#4C0519" },
  indigo: { main: "#3730A3", soft: "#EEF2FF", deep: "#1E1B4B" },
};

export const themeOf = (name) => THEMES[name] || THEMES.saffron;
